/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fancy_Vast_Otter_DanceInputs */

const fr_fancy_vast_otter_dance = /** @type {(inputs: Fancy_Vast_Otter_DanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En attente de paiement`)
};

/**

* @param {Fancy_Vast_Otter_DanceInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fancy_vast_otter_dance = /** @type {((inputs?: Fancy_Vast_Otter_DanceInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fancy_Vast_Otter_DanceInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fancy_vast_otter_dance(inputs)
});